<script lang="ts">
  import { Eye, Code } from 'lucide-svelte'
  import { editorViewStore } from '$lib/stores/editorViewStore'
  import { get } from 'svelte/store'
  
  interface Props {
    class?: string
    isPromptOpen?: boolean
    promptHeight?: number
  }
  
  let { class: className = '', isPromptOpen = false, promptHeight = 0 }: Props = $props()
  
  let storeState = $state(get(editorViewStore))
  
  // Subscribe to store changes
  $effect(() => {
    const unsubscribe = editorViewStore.subscribe(state => {
      storeState = state
    })
    
    return unsubscribe
  })
  
  function handleToggle() {
    editorViewStore.toggleMode()
  }
</script>

<button
  class="view-mode-toggle {className}"
  onclick={handleToggle}
  title="Toggle view mode (Source / WYSIWYG)"
  aria-label="Toggle between source and WYSIWYG mode"
  style="bottom: {isPromptOpen && promptHeight > 0 ? promptHeight + 16 : 10}px"
>
  {#if storeState.mode === 'source'}
    <Code size={10} />
    <span>Source</span>
  {:else}
    <Eye size={10} />
    <span>Reading</span>
  {/if}
</button>

<style>
  .view-mode-toggle {
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 4px 8px;
    background: rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    color: #666;
    font-size: 10px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    opacity: 0.7;
    position: fixed;
    left: 12px;
    z-index: 10000;
  }
  
  .view-mode-toggle:hover {
    opacity: 1;
    background: rgba(0, 0, 0, 0.15);
    color: #333;
  }
  
  .view-mode-toggle:active {
    transform: scale(0.95);
  }
  
  .view-mode-toggle span {
    text-transform: uppercase;
    letter-spacing: 0.2px;
    font-size: 8px;
  }
  
  /* Dark mode */
  :global(.dark) .view-mode-toggle {
    background: rgba(255, 255, 255, 0.05);
  }
  
  :global(.dark) .view-mode-toggle:hover {
    background: rgba(255, 255, 255, 0.1);
  }
</style>